import { apiClient } from './client';
import type { ApiSuccess } from '../types';

export interface AiSettings {
  configured: boolean;
  source: 'settings' | 'env' | 'none';
  model: string;
  keyHint: string | null;
}

export interface UpdateAiSettingsInput {
  apiKey?: string; // '' clears the stored key; omit to leave unchanged
  model?: string;
}

export const aiSettingsApi = {
  async get(): Promise<AiSettings> {
    return (await apiClient.get<ApiSuccess<AiSettings>>('/ai-settings')).data.data;
  },
  async update(input: UpdateAiSettingsInput): Promise<AiSettings> {
    return (await apiClient.put<ApiSuccess<AiSettings>>('/ai-settings', input)).data.data;
  },
};
